"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = require("./../../../Button");

var _ModalFooterContainer = _interopRequireDefault(require("./ModalFooterContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModalFooter = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ModalFooter, _React$Component);

  var _super = _createSuper(ModalFooter);

  function ModalFooter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ModalFooter);
    _this = _super.call(this, props);
    _this.buttonRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(ModalFooter, [{
    key: "focusCtaButton",
    value: function focusCtaButton() {
      if (this.buttonRef.current) {
        this.buttonRef.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelText = _this$props.cancelText,
          onCancel = _this$props.onCancel,
          confirmText = _this$props.confirmText,
          description = _this$props.description,
          onConfirm = _this$props.onConfirm,
          isWorking = _this$props.isWorking;
      return /*#__PURE__*/_react.default.createElement(_ModalFooterContainer.default, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
        ref: this.buttonRef,
        working: isWorking,
        onClick: onConfirm,
        "aria-label": "".concat(confirmText, " ").concat(description)
      }, confirmText), onCancel && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
        className: "ui-modal-cancel",
        variant: "tertiary",
        onClick: onCancel,
        "aria-label": "".concat(cancelText, " ").concat(description)
      }, cancelText), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        className: "ui-modal-cancel-mobile",
        variant: "secondary",
        onClick: onCancel,
        "aria-label": "".concat(cancelText, " ").concat(description)
      }, cancelText)));
    }
  }]);
  return ModalFooter;
}(_react.default.Component);

ModalFooter.propTypes = {
  /** _Required_ Confirm Text displayed on main Confirm CTA button. `confirmText` must be accompanied by `onConfirm`. */
  confirmText: _propTypes.default.string.isRequired,

  /** _Required_ string to describe general modal functionality. It is recommended that the end user provide a `description` since it will be used in ARIA content. */
  description: _propTypes.default.string.isRequired,

  /** _Required_ event handler called when the Confirm CTA is activated. Footer will only render if both `controlType` and `onConfirm` are declared. `onConfirm` must be accompanied by `confirmText`. */
  onConfirm: _propTypes.default.func.isRequired,

  /** _Optional_ Cancel Text displayed on cancel button. `cancelText` must be accompanied by `onCancel`. */
  cancelText: _propTypes.default.string,

  /** _Optional_ Controls visibility of cancel button and is call when cancel button is clicked. Displays cancelText. */
  onCancel: _propTypes.default.func,

  /** _Optional_ triggers working button if true  */
  isWorking: _propTypes.default.bool
};
var _default = ModalFooter;
exports.default = _default;
//# sourceMappingURL=ModalFooter.js.map